import { render, staticRenderFns } from "./changeDeptDialog.vue?vue&type=template&id=5aae6b7c&"
import script from "./changeDeptDialog.vue?vue&type=script&lang=js&"
export * from "./changeDeptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports